export const en = {
    isNotSet: 'not specified ',
    perDay: 'per day'
};
